import BaseService from '@services/base.service';
import http from '../http-common';

class FaqService extends BaseService {
  constructor() {
    super('faqs');
  }

  getAllByEnterprise(enterpriseIdentifiant) {
    return http.get(`${this.path}/enterprise/${enterpriseIdentifiant}`);
  }
}

export default new FaqService();
